import { IWindowService } from 'angular';
import * as _ from 'lodash';
import { PlannedDiplomaType } from '../../../../../../../../ng2/shared/constants/planned-diploma-type.constant';

export class MetricsSelectionRowCtrl {
  static $inject = ['$window'];

  constructor(private $window: IWindowService) {}

  public fieldLabel;
  public defaultNumExams;
  public numExamsBasedOnCurrentJuneMetric;
  public menuBasedOnJune;

  // bindings
  public label;
  public cohort;
  public currentSchool;
  public metrics;

  $onInit() {
    let menu;

    this.numExamsBasedOnCurrentJuneMetric = type => {
      let i = 1;

      menu = [0];
      _.times(this.metrics.june[type], () => {
        menu.push(i);
        i++;
      });

      // set August menu options
      this.menuBasedOnJune = menu;

      if (this.metrics.june[type] < this.metrics.aug[type]) {
        this.metrics.aug[type] = 0;
      }
    };

    // apply metrics
    if (this.label === PlannedDiplomaType.ADVANCED_REGENTS.humanName) {
      menu = [];
      this.fieldLabel = 'Min Regents Passed of 9 @ 65';
      this.defaultNumExams = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    } else if (this.label === PlannedDiplomaType.REGENTS.humanName) {
      menu = [];
      this.fieldLabel = 'Min Regents Passed of 5 @ 65';
      this.defaultNumExams = [0, 1, 2, 3, 4, 5];
    } else if (this.label === PlannedDiplomaType.LOCAL.humanName) {
      menu = [];
      this.fieldLabel = 'Min Regents Passed of 5 @ 55';
      this.defaultNumExams = [0, 1, 2, 3, 4, 5];
    }
  }
}
